import { useFiltersStore } from '@features/regional-overview/components/filters/filters.store';
import { buildTextSearchFilter } from '@features/regional-overview/components/filters/builders/text-search.builder';
import type { Filter } from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewDigitalTrapsProperties } from 'querys/regional-overview/regional-overview.query.models';
import { useEffect } from 'react';
import { useDigitalTrapsData } from '../hooks';
import TrapManagementTabs from './trap-management-tabs';
import { TrapManagementPageContainer } from './trap-management-tabs.style';

const TRAP_MANAGEMENT_ENABLED_FILTERS: Filter[] = [
  buildTextSearchFilter<RegionalOverviewDigitalTrapsProperties>({
    extractSearchable: feature => [feature.properties.group.name, feature.properties.name, feature.properties.id]
  })
];

const TrapManagementContainer = () => {
  const setEnabledFilters = useFiltersStore(state => state.setEnabledFilters);
  const resetStore = useFiltersStore(state => state.resetStore);

  useDigitalTrapsData();

  useEffect(() => {
    setEnabledFilters(TRAP_MANAGEMENT_ENABLED_FILTERS);
    return () => resetStore();
  }, [setEnabledFilters, resetStore]);

  return (
    <TrapManagementPageContainer>
      <TrapManagementTabs />
    </TrapManagementPageContainer>
  );
};

export default TrapManagementContainer;
